const isSafariOrInAppIOSBrowser = (userAgent: string) => {
    const userAgentToTestAgainst = userAgent.toLowerCase();

    const isIOS = /iphone|ipad|ipod/.test(userAgentToTestAgainst);

    const isSafari =
        /safari/.test(userAgentToTestAgainst) &&
        !/chrome|chromium|edg|firefox|opera/.test(userAgentToTestAgainst);

    return isIOS || isSafari;
};

export default isSafariOrInAppIOSBrowser;
